import { MeteoConditionsID } from '@enums/MeteoConditionsID'
import { MeteoConditionsSendDTO } from './simulation/MeteoConditionsSendDTO'

export interface MeteoConditionsDTO {
  ID: MeteoConditionsID
  VARIABLE?: string
  MIN_VALUE?: number
  MAX_VALUE?: number
  DECIMALES?: number
  IGNORE?: boolean
  VALORES: number[]
}

export namespace MeteoConditionsDTO {
  export function fromMeteoConditionsSendDTO(
    dto: MeteoConditionsSendDTO
  ): MeteoConditionsDTO {
    return {
      ID: dto.ID,
      VARIABLE: dto.VARIABLE,
      DECIMALES: dto.DECIMALES,
      VALORES: dto.VALORES
    }
  }
}
